import { useState, useRef, useEffect } from 'react';
import { handleClickOutside } from '../Components/MultiSelect/utils/MultiSelectUtils';

export const useMultiSelect = (value: string[], onChange: (value: string[]) => void) => {
  const [searchText, setSearchText] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const searchInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (menuOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [menuOpen]);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  const handleMenuItemClick = (clickedValue: string) => {
    const newValue = value.includes(clickedValue)
      ? value.filter((v) => v !== clickedValue)
      : [...value, clickedValue];
    onChange(newValue);
  };

  const handleClose = (event: React.SyntheticEvent<Element, Event>) => {
    if (handleClickOutside(event)) {
      setMenuOpen(false);
      setSearchText('');
    }
  };

  return {
    searchText,
    menuOpen,
    searchInputRef,
    handleSearchChange,
    handleMenuItemClick,
    handleClose,
    setMenuOpen,
  };
};
